<template>
  <div class="banner">
    <div class="bannerImg">
      <img :src="bannerImg" alt /> 
    </div>

    <div class="banner_text">
      <div class="wenzi">
        <img :src="wenziImg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "banner",
  data() {
    return {
      bannerImg: require("../../assets/img/pc/banner/banner.png"), 
      wenziImg: require("../../assets/img/pc/banner/title.png")
    };
  },
  created() {
    // if (window.location.host == "sxdc.chineseall.cn") {
    //   this.wenziImg = require("../../assets/img/pc/zhutid.png");
    // } else {
    //   this.wenziImg = require("../../assets/img/pc/zhuti.png");
    // }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 9.6rem;
  position: relative;
  .bannerImg {
    width: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    img {
      width: 100%;
    }
  }
  .banner_text {
    width: 12.1rem;
    height: auto;
    position: absolute;
    top: 1.32rem;
    left: 50%;
    transform: translateX(-50%);
    .wenzi {
      width: 100%;
      margin: 0 auto;
      img {
        width: 100%;
        height: auto;
      }
    }
    
  }
}
</style>
